<template>
  <div class="account-number-withdrawal-select">
    <el-select style="width:100%;"
               test_id="select_tradeaccount"
               @change="change"
               v-model="tradeAccount"
               :placeholder="$t('deposit.upload.please_sel')">
      <el-option v-for="(item,key) in accountNumbers"
                 :disabled="item.disabled"
                 :key="key"
                 :label="item.label+' | '+item.value"
                 :value="item.value"
                 :test_id ="'deposit_account_'+item.tradeAccountType"></el-option>
    </el-select>
    <!-- <bDialog :dialogVisible.sync="dialogVisible" :component="component" :contiune="contiune" :showClose="showClose"></bDialog> -->
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import _ from 'lodash'
export default {
  props: {
    'accountNumberList': { type: Array, default: () => [] },
    'isClear': {
      type: Boolean, default: false
    },
    type: {
      type: String, default: ''
    }
  },
  data () {
    return {
      accountNumbers: [],
      tradeAccount: '',
      tradeType: '',
      isDormant: false
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    ...mapState(['accountInfo', 'userInfo', 'filterSPTradingAccountList']),
    tradeAccountList () {
      return this.accountInfo
    }
  },
  watch: {
    isClear: {
      handler (val) {
        if (val) {
          this.resetAccount()
        }
      }
    }
  },
  async mounted () {
    // TODO 获取当前账号下是否有交易账号列表
    // // TODO 发送请求
    // const accountNumber = this.$getProfile().custom.accountNumber
    // const result = await this.$api.getAcountType({
    //   accountNumber: accountNumber
    // })

    this.initAccountNumbers()
  },
  methods: {
    resetAccount () {
      this.tradeAccount = ''
    },
    tradeAccountConfig (tradeAccountType) {
      return this.Util.getTradeAccountConfig(tradeAccountType)
    },
    initAccountNumbers () {
      let arr = []
      if (this.accountNumberList.length > 0) {
        this.accountNumbers = this.userInfo.isSPAccount === 'Y' ? this.filterSPTradingAccountList : this.accountNumberList
      } else {
        arr = this.userInfo.isSPAccount === 'Y' ? this.filterSPTradingAccountList : this.tradeAccountList
        if (this.type === 'exchange') {
          arr = (arr || []).filter(item => { return (['STOCK', 'FUTURES', 'FUND'].includes(item.type)) && item.status !== 'CLOSE' })
          // 换汇默认展示第一个账户
          this.tradeAccount = (arr.length && arr[0].tradeAccountNumber) || ''
          this.accountType = (arr.length && arr[0].tradeAccountType) || ''
          this.tradeType = (arr.length && arr[0].type) || ''
          this.isDormant = (arr.length && arr[0].isDormant) || false
          // this.$emit('change', arr[0])
        } else if (this.type === 'deposit') {
          // 入金显示sp账户
          arr = this.tradeAccountList.filter(item => item.status !== 'CLOSE')
        } else {
          arr = arr.filter(item => item.status !== 'CLOSE')
        }
        let accountNumnberArr = []
        for (let i = 0; i < arr.length; i++) {
          let tradeAccountType = arr[i].tradeAccountType.toLowerCase().replace(/_[a-z]/g, function (m) {
            return m.slice(1).toUpperCase()
          })
          // let tradeAccountTypeConfig = this.tradeAccountConfig(tradeAccountType)['tradeAccountType']
          let item = {}
          item.type = arr[i].type
          item.tradeType = arr[i].type
          item.label = this.$t(`tradeAccountType.${arr[i].tradeAccountType}`)
          item.value = arr[i].tradeAccountNumber
          item.accountId = this.accountInfo._id
          item.accountType = arr[i].accountType
          item.isDormant = arr[i].isDormant
          item.tradeChannel = arr[i].tradeChannel
          item._tradeAccountType = arr[i].tradeAccountType
          item.tradeAccountType = tradeAccountType
          arr[i].enabled = arr[i].status
          // switch (enabled) {
          //   case 'true':
          //     arr[i].enabled = 'OPEN'
          //     break
          //   case true:
          //     arr[i].enabled = 'OPEN'
          //     break
          //   case 'false':
          //     arr[i].enabled = 'STOP'
          //     break
          //   case false:
          //     arr[i].enabled = 'STOP'
          //     break
          //   default:
          //     arr[i].enabled = arr[i].enabled
          //     break
          // }
          if (arr[i].enabled === 'OPEN') {
            item.disabled = false
          } else {
            item.disabled = true
          }
          if (item.tradeAccountType !== 'va') {
            accountNumnberArr.push(item)
          }
        }
        this.accountNumbers = accountNumnberArr
      }
    },
    getAccountNumberInfo (val) {
      this.$api
        .getAccountNumberInfo(val, {
          accountNumber: this.$getProfile().custom.accountNumber,
          tradeAccount: val
        })
        .then(result => {
          this.$emit('accountInfo', result)
        })
    },
    change (val) {
      let tradeAccount = _.find(this.accountNumbers, { value: val })
      this.$emit('change', tradeAccount)
    }
  }
}
</script>

<style scoped>
</style>
